import { Box } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import { FC, useContext, useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PayMethod } from "../../utils/types";
import { CheckoutContext } from "../../pages/Checkout";
import { validateURL } from "../../utils/validateURL";
import { PaymentContext } from "../PaymentStatus/PaymentStatus";
import VisaForm from "./PayWithVisa";
import { useNavigate } from "react-router-dom";
import { VISA_ENDPOINT } from "../../utils/config";

const PaySubscribe: FC<PayMethod> = ({
  payMethod,
  accountNumber,
  paymentMethodId,
  setToast,
}) => {
  const { id, payment_id, recurring_payment, customerPhone, method } =
    useContext(CheckoutContext);
  const { activeStep } = useContext(PaymentContext);
  const navigate = useNavigate();

  // const subscribe = useRef(false)
  const [subscribe, setSubscribe] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const queryClient = useQueryClient();

  // Tobe Removed
  // const phone = ["251943221789", "251912050972", "251911259134", "251911254532",
  // "251932284373", "251900472370", "251975146165", "251943321789", "251911235523",
  // "251975128309","251911508525", "251911232326", "251911522547", "251911508707",
  // "251911509728", "251944781248", "251904319034", "251937692216", "251907612667", "251973114666",]
  ////
  const { mutate, data: visaResponse } = useMutation(
    (form: {
      amount: number;
      currency: string;
      transactionReference: string;
      token: any;
    }) => {
      const formData = new FormData();
      formData.append("amount", form.amount.toString());
      formData.append("currency", form.currency);
      formData.append("transactionReference", form.transactionReference);
      return axios.post(`${VISA_ENDPOINT}/payment`, formData, {
        headers: {
          Authorization: `Bearer ${form.token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        responseType: "text",
      });
    }
  );
  const webPayMutation = useMutation(
    () => {
      const device = ["Android", "iPhone"].some((divice) =>
        window.navigator.userAgent.includes(divice)
      )
        ? "mobile"
        : "";
      const webPay = recurring_payment
        ? `/user_subscriptions/${payment_id}/checkout/${payMethod}/web`
        : `/web_pay/${payment_id}/${payMethod}?device=${device}`;
      return axios.post(webPay, {
        account_number: accountNumber,
        payment_method_id: paymentMethodId,
      });
    },
    {
      onMutate: () => {
        setSubscribe(true);
      },
      onSettled: (data: any, error) => {
        if (error) {
          console.error("Payment request failed", error);
          setSubscribe(false);
          return;
        }

        let toPayUrl = recurring_payment
          ? data?.data?.data?.url
          : data?.data?.toPayUrl;

        // Extract URL if it's stringified JSON
        if (typeof toPayUrl === 'string' && toPayUrl.startsWith('{')) {
          try {
            const parsed = JSON.parse(toPayUrl);
            if (parsed.toPayUrl) {
              toPayUrl = parsed.toPayUrl;
            }
          } catch (e) {
            console.error("Failed to parse stringified toPayUrl", e);
          }
        }

        if (toPayUrl && validateURL(toPayUrl)) {
          window.location.href = toPayUrl;
        } else if (!data?.data?.token) {
          // If there is no redirect URL and no Visa token, something is wrong
          // We must release the loading button lock immediately so they can retry.
          setSubscribe(false);
        }

        if (data?.data?.token && data?.data?.token !== "") {
          const formData = {
            amount: 1,
            currency: "USD",
            transactionReference: id,
            token: data?.data?.token,
          };
          mutate(formData);
        }

        setTimeout(() => {
          queryClient.invalidateQueries({ queryKey: ["getPaymentIntent"] });
          setSubscribe(false);
        }, 30000);
      },
    }
  );

  useEffect(() => {
    if (visaResponse) {
      // document.documentElement.innerHTML = visaResponse.data.documentElement.innerHTML;
      const html = visaResponse?.data as any;
      const blob = new Blob([html], { type: "text/html" });
      const url = window.URL.createObjectURL(blob);
      window.location.replace(url);
    }
  }, [visaResponse]);

  useEffect(() => {
    if (recurring_payment && method !== "") {
      webPayMutation.mutate();
    }
  }, []);

  useEffect(() => {
    if (
      webPayMutation.isSuccess &&
      (payMethod?.includes("amharabank") || payMethod?.includes("zemenbank"))
    )
      setOpenDialog(true);
  }, [webPayMutation.isSuccess, payMethod]);

  const handlePayment = () => {
    // tobe removed
    if (payMethod.toLocaleLowerCase() === "airtime") {
      //phone.includes(customerPhone) &&
      const data: any = queryClient.getQueryData([
        "getUserSubscriptions",
        payment_id,
      ]);

      const planId = data?.data?.data?.subscription?.plan_id;
      const text =
        planId === "gbil_swmu_1d" ? "A" : planId === "gbil_swmu_1w" ? "B" : "";

      setSubscribe(true);
      webPayMutation.mutate();

      window.location.href = `sms:9107;?&body=${text}`;

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["getPaymentIntent"] });
      }, 30000);
    } else {
      webPayMutation.mutate();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LoadingButton
        loading={subscribe}
        loadingPosition="center"
        sx={{
          // mt: '1rem',
          p: "1rem",
          width: "100%",
          backgroundColor: "#FFAA00",
          borderRadius: "8px",
          ":hover": {
            backgroundColor: "#FFAA00",
          },
        }}
        variant="contained"
        size="large"
        disabled={!payMethod || subscribe}
        onClick={handlePayment}
      >
        {!recurring_payment ? "Pay" : "Subscribe"}
      </LoadingButton>
    </Box>
  );
};

export default PaySubscribe;
